export const selectSavedSearches = ({ savedSearches }) => savedSearches
